var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const formatByCurrency = (value, options, points = false) => {
  const _a = options, {
    locale = "en",
    symbol,
    pointsSymbol = "PTS",
    minimumFractionDigits = points ? 0 : void 0
  } = _a, rest = __objRest(_a, [
    "locale",
    "symbol",
    "pointsSymbol",
    "minimumFractionDigits"
  ]);
  const formatter = new Intl.NumberFormat(locale, __spreadValues({
    style: "currency",
    minimumFractionDigits
  }, rest));
  return formatter.formatToParts(value).map(({ type, value: value2 }) => {
    if (!symbol)
      return value2;
    switch (type) {
      case "currency":
        return points && pointsSymbol ? pointsSymbol : symbol;
      default:
        return value2;
    }
  }).reduce((string, part) => string + part);
};

export { formatByCurrency };
//# sourceMappingURL=bundle.esm.js.map
